/* LP v2 wizard — rendering helpers (pure DOM, no state of its own).
 *
 * window.AflWizRender:
 *   money(cents, format)            Shopify money_format → string
 *   readTile(el)                    tile element → plain piece record (incl. gallery + details data)
 *   fillGrid(grid, tiles, rows, cols, moreBtn)   clone tiles into a grid, "Show more" reveals rows
 *   pricePiece(el, listCents, pct)  writes "~~list~~ pay · 50% OFF" into a backpack tile
 *   priceGift(el, listCents, cfg)   writes "~~worth~~ FREE" into a gift tile
 *   paintGallery(root, piece, cfg)  photos + thumbs, the buy-box header, the details fold
 *   lineHtml(piece, cfg)            one receipt line
 *   totalsHtml(pieces, cfg)         the receipt totals (subtotal / save / gifts worth)
 *   fill(template, tokens)          "{worth}" → value
 * Gifts always read cfg.freeLabel ("FREE"), never "$0.00" (owner 08.09).
 * Loaded before afroyla-seen-wizard.js. */
(function () {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fill(tpl, tokens) {
    return String(tpl || '').replace(/\{(\w+)\}/g, function (m, k) {
      return tokens && k in tokens ? tokens[k] : m;
    });
  }

  /* The store's money_format ("${{amount}}", "{{amount_no_decimals}}" …). */
  function money(cents, format) {
    var amount = (Number(cents) || 0) / 100;
    var fmt = format || '${{amount}}';
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var num;
    switch (key) {
      case 'amount_no_decimals':
        num = Math.round(amount).toLocaleString('en-US');
        break;
      case 'amount_with_comma_separator':
        num = amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        num = Math.round(amount).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
        break;
      default:
        num = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, num);
  }

  /* Shopify floors a percentage discount per line the same way (see the live probe 07.09). */
  function payCents(listCents, pct) {
    return listCents - Math.floor((listCents * pct) / 100);
  }

  function list(attr) {
    return String(attr || '')
      .split('|')
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
  }

  function readTile(el) {
    return {
      el: el,
      handle: el.getAttribute('data-handle') || '',
      variantId: parseInt(el.getAttribute('data-variant-id'), 10) || 0,
      listCents: parseInt(el.getAttribute('data-list-cents'), 10) || 0,
      name: el.getAttribute('data-name') || '',
      fullName: el.getAttribute('data-full-name') || el.getAttribute('data-name') || '',
      src: el.getAttribute('data-src') || '',
      srcset: el.getAttribute('data-srcset') || '',
      images: list(el.getAttribute('data-images')),
      thumbs: list(el.getAttribute('data-thumbs')),
      meaning: el.getAttribute('data-meaning') || '',
      note: el.getAttribute('data-note') || '',
      facts: el.getAttribute('data-facts') || '',
      available: el.getAttribute('data-available') !== 'false',
      preorder: el.getAttribute('data-preorder') === 'true',
      window: el.getAttribute('data-window') || '',
      isGift: el.hasAttribute('data-wiz-gift'),
    };
  }

  function pricePiece(el, listCents, pct, fmt) {
    var out = el.querySelector('[data-wiz-tile-price]');
    if (!out) return;
    out.innerHTML = '<s>' + esc(money(listCents, fmt)) + '</s><b>' + esc(money(payCents(listCents, pct), fmt)) + '</b><span class="afl-wiz__off">' + pct + '% off</span>';
  }

  function priceGift(el, listCents, cfg) {
    var out = el.querySelector('[data-wiz-tile-price]');
    if (!out) return;
    out.innerHTML = '<s>' + esc(money(listCents, cfg.fmt)) + '</s><b class="afl-wiz__free">' + esc(cfg.freeLabel) + '</b>';
  }

  /* Clone the source tiles into a grid; the first rows×cols stay visible and
     "Show more" reveals rows×cols more per tap. Returns the clones. */
  function fillGrid(grid, sourceTiles, rows, cols, moreBtn) {
    grid.innerHTML = '';
    var pageSize = Math.max(1, rows * cols);
    var clones = sourceTiles.map(function (src, i) {
      var c = src.cloneNode(true);
      c.removeAttribute('id');
      c.removeAttribute('data-shopify-editor-block');
      c.setAttribute('aria-pressed', 'false');
      c.setAttribute('data-index', String(i));
      if (i >= pageSize) c.hidden = true;
      grid.appendChild(c);
      return c;
    });
    var shown = Math.min(pageSize, clones.length);
    if (moreBtn) {
      moreBtn.hidden = shown >= clones.length;
      moreBtn.onclick = function () {
        var next = Math.min(shown + pageSize, clones.length);
        for (var i = shown; i < next; i += 1) clones[i].hidden = false;
        shown = next;
        moreBtn.hidden = shown >= clones.length;
      };
    }
    return clones;
  }

  function shipLine(piece, cfg) {
    if (piece.preorder) return fill(cfg.shipWindow, { window: piece.window || '' });
    return cfg.shipNow;
  }

  /* Photos + thumbs, then the buy-box header (kind / name / price / ship) and
     the details fold — all looked up from the section root, wherever they sit. */
  function paintGallery(root, piece, cfg) {
    if (!root || !piece) return;
    var main = root.querySelector('[data-wiz-main]');
    var thumbs = root.querySelector('[data-wiz-thumbs]');
    var images = piece.images.length ? piece.images : [piece.src];
    var thumbList = piece.thumbs.length ? piece.thumbs : [piece.src];

    var swap = function (i) {
      if (!main) return;
      main.classList.add('is-swapping');
      var url = images[i] || images[0];
      var done = function () {
        main.src = url;
        main.alt = piece.fullName || piece.name;
        main.classList.remove('is-swapping');
      };
      var img = new Image();
      img.onload = done;
      img.onerror = done;
      img.src = url;
      if (thumbs) {
        Array.prototype.forEach.call(thumbs.children, function (b, j) {
          b.setAttribute('aria-current', j === i ? 'true' : 'false');
        });
      }
    };

    if (thumbs) {
      thumbs.innerHTML = thumbList
        .map(function (t, i) {
          return '<button type="button" class="afl-wiz__thumb" data-wiz-thumb="' + i + '" data-hc-el="gallery-thumb" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(t) + '" alt="" loading="lazy" width="120" height="160"></button>';
        })
        .join('');
      thumbs.hidden = thumbList.length < 2;
      thumbs.onclick = function (e) {
        var b = e.target.closest('[data-wiz-thumb]');
        if (b) swap(parseInt(b.getAttribute('data-wiz-thumb'), 10) || 0);
      };
    }
    swap(0);

    var set = function (sel, text, html) {
      var el = root.querySelector(sel);
      if (!el) return;
      if (html) el.innerHTML = html;
      else el.textContent = text || '';
      el.hidden = !(text || html);
    };
    set('[data-wiz-info-kind]', piece.isGift ? cfg.infoGift : cfg.infoBackpack);
    // full title on desktop, the short design name on phones (CSS picks one)
    set('[data-wiz-info-name-short]', piece.name || piece.fullName);
    var full = root.querySelector('[data-wiz-info-name-full]');
    if (full) full.textContent = piece.fullName || piece.name; // kept for a11y, stays hidden
    if (piece.isGift) {
      set('[data-wiz-info-price]', null, '<b class="afl-wiz__free">' + esc(cfg.freeLabel) + '</b><s>' + esc(money(piece.listCents, cfg.fmt)) + '</s>');
    } else {
      set('[data-wiz-info-price]', null, '<b>' + esc(money(payCents(piece.listCents, cfg.pct), cfg.fmt)) + '</b><s>' + esc(money(piece.listCents, cfg.fmt)) + '</s><span class="afl-wiz__off">' + cfg.pct + '% off</span>');
    }
    set('[data-wiz-info-ship]', shipLine(piece, cfg) + (piece.isGift ? '' : ' · ' + cfg.priceNote));
    set('[data-wiz-info-meaning]', piece.meaning);
    set('[data-wiz-info-note]', piece.note);
    set('[data-wiz-info-facts]', piece.facts);
  }

  /* One line of the receipt. `piece.kind` = 'backpack' | 'gift'. */
  function lineHtml(piece, cfg) {
    var fmt = cfg.fmt;
    var img = '<img class="afl-wiz__line-img" src="' + esc(piece.src) + '" alt="" loading="lazy" width="72" height="96">';
    if (piece.kind === 'gift') {
      return (
        '<li class="afl-wiz__line afl-wiz__line--gift">' + img +
        '<span class="afl-wiz__line-body"><span class="afl-wiz__line-name">' + esc(piece.fullName || piece.name) + '</span>' +
        '<span class="afl-wiz__line-tag">' + esc(fill(cfg.giftLine, { worth: money(piece.listCents, fmt) })) + '</span>' +
        '<span class="afl-wiz__line-ship">' + esc(shipLine(piece, cfg)) + '</span></span>' +
        '<span class="afl-wiz__line-amt"><s>' + esc(money(piece.listCents, fmt)) + '</s><b class="afl-wiz__free">' + esc(cfg.freeLabel) + '</b></span></li>'
      );
    }
    return (
      '<li class="afl-wiz__line">' + img +
      '<span class="afl-wiz__line-body"><span class="afl-wiz__line-name">' + esc(piece.name) + '</span>' +
      '<span class="afl-wiz__line-tag afl-wiz__line-tag--off">' + cfg.pct + '% off · ' + esc(cfg.priceNote) + '</span>' +
      '<span class="afl-wiz__line-ship">' + esc(shipLine(piece, cfg)) + '</span></span>' +
      '<span class="afl-wiz__line-amt"><s>' + esc(money(piece.listCents, fmt)) + '</s><b>' + esc(money(payCents(piece.listCents, cfg.pct), fmt)) + '</b></span></li>'
    );
  }

  /* The receipt totals. One number per claim (never fold the gift value into
     the save figure): subtotal = what she pays today, save = the backpack
     discount, worth = the list value of the free gifts. */
  function totalsHtml(pieces, cfg) {
    var fmt = cfg.fmt;
    var bags = 0;
    var gifts = 0;
    var listBags = 0;
    var pay = 0;
    var worth = 0;
    pieces.forEach(function (p) {
      if (p.kind === 'gift') {
        gifts += 1;
        worth += p.listCents;
      } else {
        bags += 1;
        listBags += p.listCents;
        pay += payCents(p.listCents, cfg.pct);
      }
    });
    var row = function (cls, label, value) {
      return '<div class="afl-wiz__tot ' + cls + '"><dt>' + esc(label) + '</dt><dd>' + value + '</dd></div>';
    };
    var html = row('', fill(cfg.sumBackpacks, { n: bags }), '<s>' + esc(money(listBags, fmt)) + '</s>' + esc(money(pay, fmt)));
    if (gifts) html += row('afl-wiz__tot--gift', fill(cfg.sumGifts, { n: gifts }), '<s>' + esc(money(worth, fmt)) + '</s><b class="afl-wiz__free">' + esc(cfg.freeLabel) + '</b>');
    html += row('afl-wiz__tot--sub', cfg.sumSubtotal, '<b>' + esc(money(pay, fmt)) + '</b>');
    html += row('afl-wiz__tot--save', cfg.sumSave, '−' + esc(money(listBags - pay, fmt)));
    if (gifts) html += row('afl-wiz__tot--save', cfg.sumWorth, esc(money(worth, fmt)));
    return html;
  }

  window.AflWizRender = {
    esc: esc,
    fill: fill,
    money: money,
    payCents: payCents,
    readTile: readTile,
    fillGrid: fillGrid,
    pricePiece: pricePiece,
    priceGift: priceGift,
    paintGallery: paintGallery,
    lineHtml: lineHtml,
    totalsHtml: totalsHtml,
  };
})();
